module.exports = __webpack_public_path__ + "media/src/images/site-top/icon-fukui-lg-264a4e65dd137f658c0049ee7f8db827.png";